module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "workbench-toolbar"
  }, [_c('div', {
    staticClass: "workbench-toolbar__info"
  }, [_c('div', {
    staticClass: "workbench-toolbar__info__dashboard",
    on: {
      "click": _vm.navigateToDashboard
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "color": "#C6CCD0"
    }
  }, [_vm._v("mdi-view-dashboard")]), _vm._v(" "), _c('div', {
    staticClass: "text-button pl-1"
  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('div', {
    staticClass: "workbench-toolbar__info__status_destination"
  }, [(_vm.activated && _vm.currentTarget && _vm.currentTarget.display_name) ? _c('div', {
    staticClass: "workbench-toolbar__info__status_destination__target_name"
  }, [_vm._v("\n          " + _vm._s(_vm.currentTarget.display_name) + "  |\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "workbench-toolbar__info__status_destination__destination text-overline"
  }, [_vm._v("\n          " + _vm._s(_vm.currentTarget.target_datasource) + "\n        ")]), _vm._v(" "), (_vm.currentTarget && _vm.currentTarget.viewing_stream) ? _c('div', {
    staticClass: "workbench-toolbar__info__status_destination__destination"
  }, [_vm._v("\n          " + _vm._s(_vm.currentTarget.viewing_stream) + "\n        ")]) : _vm._e(), _vm._v(" "), (
    _vm.currentTarget && _vm.currentTarget.target_type && _vm.currentTarget.target_type === _vm.audienceDiscoveryTargetType
  ) ? _c('div', {
    staticClass: "workbench-toolbar__info__status_destination__destination"
  }, [_vm._v("\n          Audience Discovery\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.dropped && _vm.currentTarget && _vm.currentTarget.activation_status) ? _c('v-chip', {
    staticClass: "workbench-toolbar__info__status_destination__status",
    attrs: {
      "label": "",
      "small": "",
      "dark": ""
    }
  }, [_vm._v(_vm._s(_vm.currentTarget.activation_status))]) : (_vm.dropped) ? _c('div', {
    staticClass: "workbench-toolbar__info__status_destination__status__dropped",
    on: {
      "click": _vm.clickedDropped
    }
  }, [_vm._v("\n          DROPPED\n        ")]) : _vm._e()], 1)]), _vm._v(" "), _c('metrics-banner', {
    attrs: {
      "metrics": _vm.metrics,
      "loading": _vm.loading
    }
  })], 1), _vm._v(" "), (_vm.showGraphs) ? [_c('distribution-graph-area', {
    staticClass: "workbench-toolbar__topArea"
  })] : _vm._e(), _vm._v(" "), _c('dropped-attributes-modal')], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76671003"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/oldWorkbench/workbenchToolbar/WorkbenchToolbar.vue
// module id = 1955
// module chunks = 0